import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDoctors } from "../redux/thunks/doctorsThunks";

import {
  selectDoctorsList,
  selectDoctorLoading,
  selectDoctorError,
} from "../redux/selectors/doctorsSelectors";

export const useDoctors = () => {
  const dispatch = useDispatch();

  const doctors = useSelector(selectDoctorsList);  
  const loading = useSelector(selectDoctorLoading);
  const error = useSelector(selectDoctorError);

  useEffect(() => {
    dispatch(fetchDoctors());
  }, [dispatch]);

  return { doctors, loading, error };
};

export default useDoctors;
